import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, Field } from 'redux-form'
import { Button, Row } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_ANULACION_EGRESO } from '../../../../../config/forms'
import { renderTextField } from '../../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator
} from '../../../../Forms/fieldValidators'

const numeric12 = getNumericValidator(9, 12)
class AnulacionEgreso0 extends Component {
  render () {
    const {
      onSubmit,
      invalid
    } = this.props

    return (
      <div>
        <Row className='justify-content-md-center' style={{ justifyContent: 'center' }}>
          <Field
            className='cpa-grande'
            name='numero'
            type='text'
            label='Numero de la carta de porte'
            component={renderTextField}
            autoFocus
            validate={[required, numeric12]}
            placeholder='10200000000'
          />
        </Row>
        <br />
        <Button
          variant='primary'
          size='lg'
          onClick={() => onSubmit()}
          disabled={invalid}
        >Siguiente</Button>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_ANULACION_EGRESO)(state)
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ANULACION_EGRESO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(AnulacionEgreso0))
